module.exports = __webpack_public_path__ + "img/readingGuide.8c70de64.webp";